import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";
import { useSeo } from "../hooks/useSeo";

const H2 = ({ children }) => (
  <h2 className="font-display text-2xl font-bold text-[#2B2B30] mt-12 mb-4 pt-8 border-t border-[#E5E0D8] first:border-0 first:pt-0 first:mt-0">
    {children}
  </h2>
);
const H3 = ({ children }) => (
  <h3 className="font-display text-lg font-semibold text-[#2B2B30] mt-6 mb-2">{children}</h3>
);
const P = ({ children }) => <p className="text-[#4A4A52] leading-relaxed mb-4">{children}</p>;

export default function Impressum() {
  useSeo("Impressum der Fussboden Blum GmbH", "Impressum und rechtliche Hinweise der Fussboden Blum GmbH");

  return (
    <div data-testid="impressum-page">
      <Navbar />
      <main>
        {/* Header band */}
        <section className="wood-band text-white pt-40 pb-16">
          <div className="container-blum">
            <Reveal>
              <p className="overline text-[#D7C4B1]">Rechtliches</p>
              <h1 className="text-4xl sm:text-5xl font-bold tracking-tight mt-4">Impressum</h1>
            </Reveal>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 lg:py-24">
          <div className="container-blum max-w-3xl">
            <H2>Angaben gemäß § 5 TMG</H2>
            <P>
              Fußboden Blum GmbH<br />
              Gewerbestraße 15<br />
              36148 Kalbach
            </P>

            <H3>Vertreten durch die Geschäftsführer</H3>
            <P>
              Michael Blum – Parkettlegermeister<br />
              Konstantin Blum – Parkettlegermeister, Handwerksmanager B.A.
            </P>

            <H3>Kontakt</H3>
            <P>
              Tel: +49 (0) 6655 – 91619 – 0<br />
              Fax: +49 (0) 6655 – 91619 – 20<br />
              Mail: <a href="mailto:info@fussboden-blum.de" className="text-[#D32F2F] hover:underline">info@fussboden-blum.de</a>
            </P>

            <H3>Registereintrag</H3>
            <P>
              Eintragung im Handelsregister.<br />
              Amtsgericht Fulda<br />
              HRB 2979
            </P>

            <H3>Umsatzsteuer-Identifikationsnummer</H3>
            <P>
              Gemäß § 27 a Umsatzsteuergesetz:<br />
              DE 176697189
            </P>

            <H2>Realisierung dieser Website</H2>
            <P>
              M3-Communication<br />
              Peterstor 23<br />
              36037 Fulda<br />
              Tel.: +49 (0)661 86 200-0<br />
              Fax.: +49 (0)661 86 200-79<br />
              Email: <a href="mailto:info@m3-communication.de" className="text-[#D32F2F] hover:underline">info@m3-communication.de</a><br />
              Internet: <a href="https://www.m3-communication.de" target="_blank" rel="noopener noreferrer" className="text-[#D32F2F] hover:underline">www.m3-communication.de</a>
            </P>
            <P>
              Dies ist ein Redaktionssystem. Für alle Inhalte, Texte und Bilder dieser Internetseite
              verantwortlich: Fußboden Blum GmbH
            </P>

            <H2>Bildnachweise / Nutzung von Bildmaterialien</H2>
            <ul className="space-y-2 mb-4 text-[#4A4A52] leading-relaxed">
              <li>/produkte/linoleum, © Forbo Flooring, <a href="https://www.forbo.com" target="_blank" rel="noopener noreferrer" className="text-[#D32F2F] hover:underline">www.forbo.com</a></li>
              <li>/produkte/kautschuk, © nora systems GmbH, norament arago, <a href="https://www.nora.com" target="_blank" rel="noopener noreferrer" className="text-[#D32F2F] hover:underline">www.nora.com</a></li>
              <li>/produkte/designbelaege, „© PROJECT FLOORS GmbH", <a href="https://www.project-floors.com" target="_blank" rel="noopener noreferrer" className="text-[#D32F2F] hover:underline">www.project-floors.com</a></li>
              <li>/produkte/pvc, „© Gerflor Mipolam GmbH", <a href="https://www.gerflor.de" target="_blank" rel="noopener noreferrer" className="text-[#D32F2F] hover:underline">www.gerflor.de</a></li>
            </ul>

            <H2>Haftungsausschluss</H2>
            <H3>Haftung für Inhalte</H3>
            <P>
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
              Als Dienstleistungsanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen
              Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
              Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche
              Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
              möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte
              umgehend entfernen.
            </P>
            <H3>Haftung für Links</H3>
            <P>
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
              Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
              mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung
              nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch
              ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </P>
            <H3>Urheberrecht</H3>
            <P>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
              Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind
              nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser
              Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.
              Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf
              eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis.
              Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </P>
            <H3>Datenschutz</H3>
            <P>
              Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich.
              Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder
              eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis.
              Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
            </P>
            <P>
              Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation
              per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem
              Zugriff durch Dritte ist nicht möglich.
            </P>
            <P>
              Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte
              zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien
              wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich
              ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von
              Werbeinformationen, etwa durch Spam-Mails, vor.
            </P>
            <H3>Cookies und Google Analytics</H3>
            <P>
              Diese Website verwendet Cookies. Cookies sind kleine Textdateien, die vom Webserver an
              Ihren PC verschickt werden und meist auf Ihrer Festplatte abgespeichert werden. Es handelt
              sich dabei nicht um Programme, die in das System des Benutzers eindringen und dort Schaden
              anrichten können. Obwohl Cookies den von Ihnen benutzten Computer identifizieren können,
              werden von Cookies selbst keine personenbezogenen Daten gespeichert. Wir verwenden Cookies
              nur im Zusammenspiel mit Ihrem Internet-Browser zur Optimierung der Benutzerfreundlichkeit
              unseres Internetangebots. Hierbei handelt es sich um temporäre Cookies, die keinerlei Daten
              auf Ihrer Festplatte bleibend abspeichern. Unsere Cookies sind nur während Ihrer
              Online-Sitzung aktiv.
            </P>
            <P>
              Die meisten Browser sind so eingestellt, dass sie Cookies automatisch akzeptieren. Sie
              können das Speichern von Cookies jedoch deaktivieren oder Ihren Browser so einstellen, dass
              er Sie benachrichtigt, sobald Cookies gesendet werden. Sie haben das Recht und die
              Möglichkeit, unsere Cookies abzulehnen. Falls Sie in Ihrem Browser die Funktion Cookies
              deaktiviert haben, können Sie unter Umständen einige Funktionen unseres Internetangebotes
              nicht benutzen.
            </P>
            <P>
              Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. („Google").
              Google Analytics verwendet sog. „Cookies", Textdateien, die auf Ihrem Computer gespeichert
              werden und die eine Analyse der Benutzung der Website durch Sie ermöglicht. Die durch den
              Cookie erzeugten Informationen über Ihre Benutzung dieser Website (einschließlich Ihrer
              IP-Adresse) wird an einen Server von Google in den USA übertragen und dort gespeichert.
              Google wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um
              Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um
              weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu
              erbringen.
            </P>
            <P>
              Auch wird Google diese Informationen gegebenenfalls an Dritte übertragen, sofern dies
              gesetzlich vorgeschrieben oder soweit Dritte diese Daten im Auftrag von Google verarbeiten.
              Google wird in keinem Fall Ihre IP-Adresse mit anderen Daten der Google in Verbindung
              bringen. Sie können die Installation der Cookies durch eine entsprechende Einstellung Ihrer
              Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
              gegebenenfalls nicht sämtliche Funktionen dieser Website voll umfänglich nutzen können.
            </P>
            <P>
              Durch die Nutzung dieser Website erklären Sie sich mit der Bearbeitung der über Sie
              erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor
              benannten Zweck einverstanden.
            </P>
            <H3>Datenschutzerklärung für die Nutzung von Facebook-Plugins</H3>
            <P>
              Auf unseren Seiten sind Plugins des sozialen Netzwerks Facebook, 1601 South California
              Avenue, Palo Alto, CA 94304, USA integriert. Die Facebook-Plugins erkennen Sie an dem
              Facebook-Logo oder dem „Like-Button" („Gefällt mir") auf unserer Seite. Eine Übersicht über
              die Facebook-Plugins finden Sie hier:{" "}
              <a href="http://developers.facebook.com/docs/plugins/" target="_blank" rel="noopener noreferrer" className="text-[#D32F2F] hover:underline break-words">http://developers.facebook.com/docs/plugins/</a>. Wenn
              Sie unsere Seiten besuchen, wird über das Plugin eine direkte Verbindung zwischen Ihrem
              Browser und dem Facebook-Server hergestellt. Facebook erhält dadurch die Information, dass
              Sie mit Ihrer IP-Adresse unsere Seite besucht haben. Wenn Sie den Facebook „Like-Button"
              anklicken während Sie in Ihrem Facebook-Account eingeloggt sind, können Sie die Inhalte
              unserer Seiten auf Ihrem Facebook-Profil verlinken. Dadurch kann Facebook den Besuch
              unserer Seiten Ihrem Benutzerkonto zuordnen. Wir weisen darauf hin, dass wir als Anbieter
              der Seiten keine Kenntnis vom Inhalt der übermittelten Daten sowie deren Nutzung durch
              Facebook erhalten. Weitere Informationen hierzu finden Sie in der Datenschutzerklärung von
              Facebook unter{" "}
              <a href="http://de-de.facebook.com/policy.php" target="_blank" rel="noopener noreferrer" className="text-[#D32F2F] hover:underline break-words">http://de-de.facebook.com/policy.php</a>
            </P>
            <P>
              Wenn Sie nicht wünschen, dass Facebook den Besuch unserer Seiten Ihrem Facebook-Nutzerkonto
              zuordnen kann, loggen Sie sich bitte aus Ihrem Facebook-Benutzerkonto aus.
            </P>

            <H2>Hinweis gemäß § 36 Verbraucherstreitbeilegungsgesetz (VSBG)</H2>
            <P>
              Der Auftragnehmer/Verkäufer wird nicht an einem Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle im Sinne des VSBG teilnehmen und ist hierzu auch nicht
              verpflichtet.
            </P>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
